import React from "react";
import { useState } from "react";
import { Card, Button, } from "antd";
import { useNavigate } from "react-router-dom";
import RM_Table from "./RM_Table";
import PusthiMSPCReportScreen from "./PusthiMSPCReportScreen";

// Pill component
const Pill = ({ text, completed }) => (
  <span
    style={{
      padding: "4px 12px",
      borderRadius: 12,
      fontSize: 14,
      fontWeight: 600,
      color: completed ? "#19a459" : "#b7b7bc",
      background: completed ? "#d7f5e6" : "#f1f1f1",
    }}
  >
    {text}
  </span>
);

const detailRows = [
  { label: "Pusthi", code: "PUS", action: "View Pusthi MSPC Report", status: "Completed" },
  { label: "Millet Laddu Mother", code: "MLM", status: "Not Started" },
  { label: "Millet Laddu Child", code: "MLC", status: "Not Started" },
  { label: "Anna Sambar Child", code: "ANC", status: "Not Started" },
  { label: "Anna Sambar Mother", code: "ASM", status: "Not Started" },
  { label: "Upitu Masala Mother", code: "UPM", status: "Not Started" },
  { label: "Upitu Masala Child", code: "UPC", status: "Not Started" },
  { label: "KIT - 1", code: "KIT", status: "Not Started" }
];

const DetailRow = ({ row, onLabelClick,onViewPusthi }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      border: "1.3px solid #edeff3",
      borderRadius: 14,
      padding: "16px 28px",
      marginBottom: 17,
      background: "#fff"
    }}
  >
    <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
      <span
  style={{
    fontWeight: 600,
    fontSize: 17,
    color: "#232c29",
    cursor:
      row.label === "Pusthi" || row.label === "Millet Laddu Mother"
        ? "pointer"
        : "default",
  }}
  onClick={() => {
    if (
      (row.label === "Pusthi" || row.label === "Millet Laddu Mother") &&
      typeof onLabelClick === "function"
    ) {
      onLabelClick();
    }
  }}
>
  {row.label}
</span>

      <span style={{ marginLeft: 8, color: "#b7b7bc", fontWeight: 500, fontSize: 14 }}>
        ({row.code})
      </span>
    </div>

    {row.action && (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          if (row.label === "Pusthi" && typeof onViewPusthi === "function") {
            onViewPusthi();
          }
        }}
        style={{
          marginRight: 26,
          color: "#1378f4",
          fontWeight: 600,
          fontSize: 15,
          textDecoration: "underline"
        }}
      >
        {row.action}
      </a>
    )}

    <Pill text={row.status === "Completed" ? "Completed" : "Not Started"} completed={row.status === "Completed"} />
  </div>
);

const DetailScreen = ({ record }) => {
  const navigate = useNavigate();
   const [showReport, setShowReport] = useState(false);
   const[showRMTable,setShowRMTable]=useState(false);
   
if (showRMTable) {
  return <RM_Table onClose={() => setShowRMTable(false)} />;
}

  if (showReport) {
    return <PusthiMSPCReportScreen onClose={() => setShowReport(false)} />;
  }

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh",width:"100%",padding: "38px  24px " }}>
      <Card
        style={{
          width:"100%",
          margin: "0",
          boxShadow: "0 2px 8px #f0f1f2",
          borderRadius: 18,
          border: "none"
        }}
        bodyStyle={{ background: "#fff", padding: 38, paddingTop: 28 }}
      >
        {/* Header */}
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 18,
          marginBottom: 30,
          marginTop: 6
        }}>
          <span style={{
            background: "#f3f4f7",
            color: "#232c29",
            padding: "7px 22px",
            fontWeight: 600,
            borderRadius: 14,
            fontSize: 15,
            border: "1px solid #e6e6eb"
          }}>File : <span style={{ fontWeight: 700 }}>{record?.fileId || "KTKKAR0825"}</span></span>

          <span style={{
            background: "#f3f4f7",
            color: "#232c29",
            padding: "7px 24px",
            fontWeight: 600,
            borderRadius: 14,
            fontSize: 15,
            border: "1px solid #e6e6eb"
          }}>Month : <span style={{ fontWeight: 700 }}>{record?.month || "June 2025"}</span></span>

          <span style={{
            background: "#f3f4f7",
            color: "#232c29",
            padding: "7px 24px",
            fontWeight: 600,
            borderRadius: 14,
            fontSize: 15,
            border: "1px solid #e6e6eb"
          }}>T.B: <span style={{ fontWeight: 700 }}>1245434</span></span>

          <Button
            style={{
              background: "#19a459",
              color: "#fff",
              marginLeft: "auto",
              padding: "0 44px",
              height: 38,
              fontWeight: 600,
              border: 0,
              borderRadius: 8,
              fontSize: 16,
              letterSpacing: "1px"
            }}
            onClick={() => navigate("/master/raw-material-planning/preview", { state: { record } })}
          >
            Preview
          </Button>
        </div>

        {/* Detail Rows */}
        <div>
          {detailRows.map((row) => (
            <DetailRow key={row.label} row={row} 
            onLabelClick={() => setShowRMTable(true)}  
            onViewPusthi={() => setShowReport(true)}/>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default DetailScreen;